import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tab } from '@headlessui/react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
// --- YENİ: Oluşturduğumuz component'i import ediyoruz ---
import ForgotPasswordForm from '../components/ForgotPasswordForm';

// Google ikonu için basit bir SVG
const GoogleIcon = (props) => (
  <svg {...props} viewBox="0 0 48 48"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571l6.19,5.238C42.022,36.218,44,30.551,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path></svg>
);

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function AuthPage() {
  const { login, register, signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  // --- YENİ: Hangi formun gösterileceğini tutan state ---
  const [view, setView] = useState('login'); // 'login', 'register', 'forgot-password'

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [agreedToMarketing, setAgreedToMarketing] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { error } = await login(email, password);
      if (error) throw error;
      toast.success('Giriş başarılı!');
      navigate('/');
    } catch (err) {
      setError(err.message);
      toast.error(err.message || 'Giriş başarısız oldu.');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== passwordRepeat) {
      toast.error('Şifreler uyuşmuyor!');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const { error } = await register(email, password, {
        data: {
          full_name: `${firstName} ${lastName}`
        }
      });
      if (error) throw error;
      navigate('/');
    } catch (err) {
      setError(err.message);
      toast.error(err.message || 'Kayıt başarısız oldu.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
        const { error } = await signInWithGoogle();
        if(error) throw error;
    } catch (err) {
        toast.error(err.message || "Google ile giriş yapılamadı.");
        setLoading(false);
    }
  }

  return (
    <div className="flex items-center justify-center min-h-full py-12">
      <div className="w-full max-w-md px-2 py-8 sm:px-0">
        <Tab.Group>
          <Tab.List className="flex space-x-1 rounded-xl bg-gray-200 p-1">
            <Tab onClick={() => setView('login')} className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-base font-medium leading-5 text-brand-green', 'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-brand-green-light ring-white ring-opacity-60', selected ? 'bg-white shadow' : 'text-gray-600 hover:bg-white/[0.6]')}>Giriş Yap</Tab>
            <Tab onClick={() => setView('register')} className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-base font-medium leading-5 text-brand-green', 'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-brand-green-light ring-white ring-opacity-60', selected ? 'bg-white shadow' : 'text-gray-600 hover:bg-white/[0.6]')}>Üye Ol</Tab>
          </Tab.List>

          <Tab.Panels className="mt-2">
            {/* Giriş Yap Paneli */}
            <Tab.Panel className="rounded-xl bg-white p-6 pt-8 shadow-lg">
              {/* --- YENİ: view state'ine göre koşullu render --- */}
              {view === 'login' && (
                <div className="animate-fade-in">
                  <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                      <label htmlFor="login-email" className="sr-only">E-posta</label>
                      <input id="login-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="E-posta adresiniz" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green" />
                    </div>
                    <div className="relative">
                      <label htmlFor="login-password"className="sr-only">Şifre</label>
                      <input id="login-password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required placeholder="Şifreniz" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green"/>
                      <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500">
                        {showPassword ? <EyeSlashIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
                      </button>
                    </div>
                    <div className="text-right text-sm">
                      <button type="button" onClick={() => setView('forgot-password')} className="font-medium text-brand-green-light hover:text-brand-green">Şifremi unuttum</button>
                    </div>
                    <button type="submit" disabled={loading} className="w-full bg-brand-green hover:bg-brand-green-light text-white font-bold py-3 rounded-md transition-colors disabled:opacity-50">{loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}</button>
                  </form>
                  <div className="mt-6">
                    <div className="relative"><div className="absolute inset-0 flex items-center"><div className="w-full border-t border-gray-300"/></div><div className="relative flex justify-center text-sm"><span className="px-2 bg-white text-gray-500">veya</span></div></div>
                    <button onClick={handleGoogleSignIn} disabled={loading} className="mt-6 w-full flex items-center justify-center gap-3 border border-gray-300 py-2.5 px-4 rounded-md hover:bg-gray-50 disabled:opacity-50"><GoogleIcon className="w-6 h-6"/>Google ile Giriş Yap</button>
                  </div>
                </div>
              )}
              
              {/* --- YENİ: Şifremi unuttum formu burada gösterilecek --- */}
              {view === 'forgot-password' && (
                <ForgotPasswordForm setView={setView} />
              )}
            </Tab.Panel>

            {/* Üye Ol Paneli */}
            <Tab.Panel className="rounded-xl bg-white p-6 pt-8 shadow-lg">
              <form onSubmit={handleRegister} className="space-y-4">
                <div className="flex gap-4">
                  <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} required placeholder="Adınız" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green" />
                  <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} required placeholder="Soyadınız" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green" />
                </div>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="E-posta adresiniz" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green" />
                <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="Cep Telefonu (İsteğe Bağlı)" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green" />
                <div className="relative">
                  <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required placeholder="Şifreniz" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green"/>
                   <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500">
                    {showPassword ? <EyeSlashIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
                  </button>
                </div>
                <input type="password" value={passwordRepeat} onChange={e => setPasswordRepeat(e.target.value)} required placeholder="Şifreniz (Tekrar)" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green" />
                <div className="space-y-4 pt-2">
                   <label className="flex items-start gap-3 text-xs text-gray-600"><input type="checkbox" checked={agreedToTerms} onChange={e => setAgreedToTerms(e.target.checked)} className="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-green focus:ring-brand-green"/><span>Kişisel verileriniz, <a href="/aydinlatma-metni" target="_blank" className="underline">Aydınlatma Metni</a> kapsamında işlenmektedir. “Üye Ol” butonuna basarak <a href="/uyelik-sozlesmesi" target="_blank" className="underline">Üyelik Sözleşmesi</a>’ni okuduğunuzu ve kabul ettiğinizi onaylıyorsunuz.</span></label>
                   <label className="flex items-start gap-3 text-xs text-gray-600"><input type="checkbox" checked={agreedToMarketing} onChange={e => setAgreedToMarketing(e.target.checked)} className="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-green focus:ring-brand-green"/><span>İndirim ve kampanyalardan haberdar olmak için <a href="/ticari-ileti-izni" target="_blank" className="underline">Ticari İletişim İzni Metni</a> kapsamında kişisel verilerimin işlenmesine ve aktarılmasına, bu çerçevede tarafıma ticari ileti gönderilmesine onay veriyorum.</span></label>
                </div>
                <button type="submit" disabled={loading || !agreedToTerms} className="w-full bg-brand-green hover:bg-brand-green-light text-white font-bold py-3 rounded-md transition-colors disabled:opacity-50">{loading ? 'Kaydolunuyor...' : 'Üye Ol'}</button>
              </form>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}

export default AuthPage;